import React from "react";
import IndustryPage from "./IndustryPage";

const HealthcarePage: React.FC = () => {
  return <IndustryPage industryKey="healthcare" />;
};

export default HealthcarePage;
